/**
 * The 100ms role names the platform puts in every link. They must match the
 * 100ms template and the platform's 100MS_INTERVIEWER_ROLE /
 * 100MS_INTERVIEWEE_ROLE (see CLAUDE.md, "URLs, roles and tokens").
 */
export const INTERVIEWER = "interviewer";
export const INTERVIEWEE = "interviewee";

/** 100ms's own roles, such as the recorder, which are never shown. */
export function isInternalRole(role = "") {
  return role.startsWith("__internal");
}
